import type {Result, UseCase} from 'framework';
import type {AuthRepository, RequestPasswordResetData} from '../ports/auth.repository';
import type {RequestPasswordResetError} from '../../domain/errors';

export class RequestPasswordReset
  implements UseCase<[RequestPasswordResetData], undefined>
{
  constructor(private readonly authRepository: AuthRepository) {}

  execute(
    data: RequestPasswordResetData,
  ): Promise<Result<undefined, RequestPasswordResetError>> {
    return this.authRepository.requestPasswordReset(data);
  }
}
